import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class ControlEfectivoService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    GetByDetalleCajaDiaria(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: control_efectivoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            control_efectivo {
              detalleCajaDiaria(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros{
                    rut_emisor
                    sucursal_codigo
                    folio
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    fecha_declaracion
                    banco_codigo
                    banco_nombre
                    monto
                    recorrido_codigo
                    numero_doc
                    tipo_pago_codigo
                    tipo_pago_nombre
                    existe_protesto
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.control_efectivo.detalleCajaDiaria;
            callback({ mensajes, respuesta });
        });
    }
    GetByDetalleCajaDiariaExcelPDF(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
        query ($entidad: control_efectivoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            control_efectivo {
              detalleCajaDiaria(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros{
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.control_efectivo.detalleCajaDiaria;
            callback({ mensajes, respuesta });
        });
    }
}
ControlEfectivoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ControlEfectivoService_Factory() { return new ControlEfectivoService(i0.ɵɵinject(i1.GraphQLClient)); }, token: ControlEfectivoService, providedIn: "root" });
